var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagKuwait(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0048 21.8357C31.6479 20.1023 32 18.2276 32 16.2705C32 14.3133 31.6479 12.4386 31.0048 10.7053L16 9.31396L0.995188 10.7053C0.352063 12.4386 0 14.3133 0 16.2705C0 18.2276 0.352063 20.1023 0.995188 21.8357L16 23.227L31.0048 21.8357Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32.2708C22.8794 32.2708 28.7441 27.9288 31.0048 21.8359H0.995132C3.25588 27.9288 9.12051 32.2708 16 32.2708Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0.270508C9.12051 0.270508 3.25588 4.61251 0.995132 10.7053H31.0048C28.7441 4.61251 22.8794 0.270508 16 0.270508Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68625 4.95654C-1.56212 11.2049 -1.56212 21.3356 4.68625 27.584C6.31719 25.9531 7.90906 24.3612 10.4347 21.8355V10.7051L4.68625 4.95654Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15835"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.270508)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagKuwait);
export default __webpack_public_path__ + "static/media/flag_kuwait.45fa4bed599b72a14a498483ab8edcda.svg";
export { ForwardRef as ReactComponent };